import React, { FC, useMemo, useRef } from 'react'

import { observer } from 'mobx-react'

import { ModalView } from 'components/ModalView'

import { useStore } from 'store'

import styles from './styles.module.scss'

interface IProps {
  open: boolean
  setOpen: (value: boolean) => void
  isVideoReady: boolean
  setIsVideoReady: (value: boolean) => void
  withAnimation?: boolean
}

export const VideoModal: FC<IProps> = observer(
  ({ open, setOpen, setIsVideoReady, withAnimation, isVideoReady }) => {
    const { loading } = useStore()
    const videoRef = useRef<HTMLVideoElement | null>(null)

    const closeModal = () => {
      videoRef.current?.pause()
      setOpen(false)
    }

    const onVideoReady = () => {
      setIsVideoReady(true)
      loading.setLoading(false)
    }

    const videoContent = useMemo(
      () => (
        <>
          {(open || isVideoReady) && (
            <video
              ref={videoRef}
              controls
              className={styles.video}
              preload="metadata"
              onLoadedMetadata={onVideoReady}
            >
              <source
                src="https://authencity.io/files/Authencity.mp4"
                type="video/mp4"
              />
            </video>
          )}
        </>
      ),
      [open, isVideoReady]
    )

    return (
      <ModalView
        withAnimation
        onClose={closeModal}
        open={open}
        unmountModal={false}
        closeButton={true}
        style={{ width: '95vw', height: 'auto' }}
        children={<div className={styles.nftContainer}>{videoContent}</div>}
      />
    )
  }
)
